import React, { useEffect, useState } from 'react';
import NumberInputWithUnit from '../../../../../../atomic/inputs/numberInputWithUnit/NumberInputWithUnit';
import PreserveProfitDocs from '../../../../documentation/PreserveProfitDocumentation';
import InfoIconComponent from '../../InfoIcon';
import style from './ExitTacticModules.module.css';
import PropTypes from 'prop-types';

function PreserveProfitModule({ state }) {
  const [preserveProfit, dispatchPreserveProfit, , setPreserveProfitEnabled] =
    state;

  const [activationProfitAmountDisplay, setActivationProfitAmountDisplay] =
    useState('');
  const [amountDisplay, setAmountDisplay] = useState('');

  useEffect(() => {
    setPreserveProfitEnabled(true);
  }, []);
  useEffect(() => {
    setAmountDisplay(preserveProfit.amount ?? 0);
    setActivationProfitAmountDisplay(preserveProfit.activationProfitAmount ?? 0);
  }, [state]);

  return (
    <div className={style.moduleStyle}>
      <span className={style.tacticName}>
        <InfoIconComponent docs={PreserveProfitDocs} /> Preserve Profit
      </span>
      <div className={style.inputs}>
        <div className={style.inputAndLabel} style={{ gridColumn: 'span 2' }}>
          <p>Activation Amount</p>
          <NumberInputWithUnit
            inputWidth="70px"
            direction="left"
            type="number"
            value={activationProfitAmountDisplay}
            setValue={setActivationProfitAmountDisplay}
            onBlur={(value) => {
              if (Number(value) < Number(amountDisplay)) {
                dispatchPreserveProfit({
                  activationProfitAmount: amountDisplay,
                });
              } else dispatchPreserveProfit({ activationProfitAmount: value });
            }}
          >
            $
          </NumberInputWithUnit>
        </div>
        <div className={style.inputAndLabel}>
          <p>Preserve Amount</p>
          <NumberInputWithUnit
            inputWidth="70px"
            direction="left"
            type="number"
            value={amountDisplay}
            setValue={setAmountDisplay}
            onBlur={(value) => {
              if (Number(activationProfitAmountDisplay) < Number(value)) {
                dispatchPreserveProfit({ activationProfitAmount: value });
              }
              dispatchPreserveProfit({ amount: value });
            }}
          >
            $
          </NumberInputWithUnit>
        </div>
      </div>
    </div>
  );
}
PreserveProfitModule.propTypes = {
  state: PropTypes.array.isRequired,
};
export default PreserveProfitModule;
